import assert from "assert";
import { CompanyMemberTypeEnum } from "./apis/model/CompanyMemberTypeEnum";
import { describeCompanyMemberTypeEnum } from "./apis/model/describeCompanyMemberTypeEnum";
import { describeGenderEnum } from "./apis/model/describeGenderEnum";
import { describeImageSizeTypeEnum } from "./apis/model/describeImageSizeTypeEnum";
import { GenderEnum } from "./apis/model/GenderEnum";
import { ImageSizeTypeEnum } from "./apis/model/ImageSizeTypeEnum";
import { ImageViewModel } from "./apis/model/ImageViewModel";

// 日期过滤 "YYYY-MM-DD"
export function formatDate_ymd(dateStr: string): string {
  const date = new Date(dateStr);
  const Y = date.getFullYear() + "-";
  const M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
  const D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  const df = Y + M + D;
  return df;
}

export function formatDateYyyyMmDdHhMmSs(date: Date): string {
  const Y = date.getFullYear() + "-";
  const M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
  const D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
  const h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":";
  const m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":";
  const s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  const df = Y + M + D + h + m + s;
  return df;
}

// 日期过滤 "YYYY-MM-DD HH:mm:ss"
export function formatDate_ymd_hms(dateStr: string): string {
  const date = new Date(dateStr);
  return formatDateYyyyMmDdHhMmSs(date);
}

export function formatGender(value: GenderEnum): string {
  return describeGenderEnum(value);
}

export function formatCompanyMember(value: CompanyMemberTypeEnum): string {
  return describeCompanyMemberTypeEnum(value);
}

export function formatImageUrl(imageUrl: string, size: ImageSizeTypeEnum): string {
  assert(imageUrl, "imageUrl falsy");
  if (imageUrl.includes("@")) return imageUrl;
  return imageUrl + describeImageSizeTypeEnum(size);
}

export function makeImageUrlFormatter(size: ImageSizeTypeEnum) {
  return (image: ImageViewModel) => {
    assert(image && image.AbsoluteUrl, "invalid image view model");
    return formatImageUrl(image.AbsoluteUrl, size);
  };
}

export function stripImageUrlResolutionPostfix(imageUrl: string): string {
  const idx = imageUrl.indexOf("@");
  if (idx > -1) {
    return imageUrl.substr(0, idx);
  }
  return imageUrl;
}
